/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Email_Settings_Remove_BannerInputs */

const en_admin_email_settings_remove_banner = /** @type {(inputs: Admin_Email_Settings_Remove_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove banner`)
};

const de_admin_email_settings_remove_banner = /** @type {(inputs: Admin_Email_Settings_Remove_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Banner entfernen`)
};

/**
* | output |
* | --- |
* | "Remove banner" |
*
* @param {Admin_Email_Settings_Remove_BannerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_email_settings_remove_banner = /** @type {((inputs?: Admin_Email_Settings_Remove_BannerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Email_Settings_Remove_BannerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_email_settings_remove_banner(inputs)
	return en_admin_email_settings_remove_banner(inputs)
});